import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d2218fe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "data-table-wrapper bottom-pagination",
  style: {
    "position": "relative"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading-content"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white"
  }
}, "Loading...")], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["loading-mask", {
      'is-loading': _ctx.isLoading
    }])
  }, _hoisted_3, 2), _ctx.showPagination ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    "current-page": _ctx.settings.page,
    total: _ctx.total,
    "page-sizes": _ctx.settings.pageSizeOptions,
    "page-size": _ctx.settings.pageSize,
    layout: _ctx.isMobile ? '->, prev, pager, next' : 'sizes,->, prev, pager, next',
    "pager-count": _ctx.isMobile ? 5 : 7,
    "onUpdate:currentPage": _ctx.onPageChanged,
    "onUpdate:pageSize": _ctx.onPageSizeChanged
  }, null, 8, ["current-page", "total", "page-sizes", "page-size", "layout", "pager-count", "onUpdate:currentPage", "onUpdate:pageSize"])) : _createCommentVNode("", true), _createVNode(_component_el_table, {
    "show-header": _ctx.rows.length > 0,
    class: _normalizeClass({
      'no-highlight': _ctx.highlightRow !== true
    }),
    "row-class-name": _ctx.rowClassSelector,
    data: _ctx.rows,
    "default-sort": _ctx.currentSort,
    onCellMouseEnter: _ctx.onMouseEnter,
    onCellMouseLeave: _ctx.onMouseLeave,
    onSortChange: _ctx.onSortChanged,
    onRowClick: _ctx.onRowClick
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
      return _openBlock(), _createBlock(_component_el_table_column, _mergeProps({
        key: index
      }, col, {
        sortable: col.sortBy && 'custom',
        "sort-by": col.sortBy
      }), _createSlots({
        _: 2
      }, [col.customizable ? {
        name: "header",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, `${col.customizable}_header`, {}, () => [_createTextVNode(_toDisplayString(col.label), 1)], true)]),
        key: "0"
      } : undefined, col.customizable ? {
        name: "default",
        fn: _withCtx(scope => [_renderSlot(_ctx.$slots, col.customizable, {
          row: scope.row
        }, () => [_createTextVNode(_toDisplayString(col.customizable), 1)], true)]),
        key: "1"
      } : undefined]), 1040, ["sortable", "sort-by"]);
    }), 128))], true)]),
    _: 3
  }, 8, ["show-header", "class", "row-class-name", "data", "default-sort", "onCellMouseEnter", "onCellMouseLeave", "onSortChange", "onRowClick"])]);
}